import { II18nextPrefix } from 'types/components/components.interface';

import { Form, Formik, FormikConfig } from 'formik';
import { useTranslation } from 'react-i18next';
import { IFormikProps, IFormProps } from '../types';

import { TabsNavigation } from 'components/molecules';
import TopBar from 'components/organisms/top-bar/TopBar';
import { TopbarTabs } from 'components/templates';

import i18next from 'i18next';
import { IChannelMutationForm } from 'services/channel/types/query';
import { array, boolean, object } from 'yup';
import { settlementInfoContractValidation } from '../music-product-digital/MusicProductDigitalForm';
import ChannelContracts from './tabs/ChannelContracts';
import ChannelContractsFuture from './tabs/ChannelContractsFuture';
import ChannelContractsHistory from './tabs/ChannelContractsHistory';
import ChannelData from './tabs/ChannelData';
import ChannelVideo from './tabs/ChannelVideo';

export enum ChannelTabs {
  external,
  remarks,
}

export const channelInitialValues: IChannelMutationForm = {
  id: '',
  link: '',
  name: '',
  imageLink: '',
  settlementInfo: { perVideoSettlement: false, contracts: [] },
  subscribersCount: 0,
  lastSyncDate: '',
  totalViews: 0,
  totalVideoCount: 0,
  version: 0,
};

export const settlementInfoValidation = object().shape({
  perVideoSettlement: boolean().when('contracts', {
    is: (contracts: any[]) => !!contracts?.length,
    then: schema => schema.required(() => i18next.t('formik-error.required')),
    otherwise: schema => schema.nullable(),
  }),
  contracts: array().of(settlementInfoContractValidation),
});

const validator = object().shape({
  settlementInfo: settlementInfoValidation.nullable(),
});

export interface IChannelForm
  extends FormikConfig<IChannelMutationForm>, IFormProps, II18nextPrefix {}

const ChannelForm = ({
  i18nextPrefix,

  topbarContent,
  tittle,
  status,
  initialValues = channelInitialValues,
  disableTabs,
  backPath,
  customBackItem,
  ...props
}: IChannelForm) => {
  const { t } = useTranslation();

  return (
    <Formik
      {...props}
      validateOnChange
      validateOnBlur
      validateOnMount
      initialStatus={status}
      enableReinitialize
      validationSchema={validator}
      initialValues={initialValues}>
      {({
        setFieldValue,
        values,
        status,
        errors,
      }: IFormikProps<IChannelMutationForm>) => (
        <Form className='w-full h-full'>
          <TopbarTabs>
            <TopBar
              customBackItem={customBackItem}
              title={tittle}
              path={backPath ?? 'channel'}
              topbarContent={topbarContent}>
              <TabsNavigation
                tabs={[
                  {
                    value: 0,
                    name: 'data',
                  },
                  {
                    value: 1,
                    name: 'contracts',
                    error: errors.settlementInfo,
                  },
                  {
                    value: 2,
                    name: 'channel-video',
                  },
                ]}
                disabled={disableTabs}
                displayMode={status?.displayMode}
              />
            </TopBar>
          </TopbarTabs>
        </Form>
      )}
    </Formik>
  );
};

ChannelForm.getRouterTabs = (disabledChildren?: string[]) =>
  [
    { path: 'contracts', element: <ChannelContracts /> },
    { path: 'contracts/future', element: <ChannelContractsFuture /> },
    { path: 'contracts/history', element: <ChannelContractsHistory /> },
    { path: 'channel-video', element: <ChannelVideo /> },
    { path: 'data', element: <ChannelData /> },
  ].filter(children => !disabledChildren?.includes(children.path));

export default ChannelForm;
